import { Box } from "@mui/material";
import { useState } from "react";
import { CatalogFilter } from "services/organizationPortalClient";
import LiveOnlineCatalogFilter from "./LiveOnlineCatalogFilter";
import ListView from "./ListView";
import CalendarView from "./CalendarView";
import { RoundedBox, TableViewType, ViewSwitch } from "@knowfully/ui.common";

const VIEWS: TableViewType[] = ["list", "calendar"];

export default function LiveOnlineTab() {
  const [filter, setFilter] = useState({} as CatalogFilter);
  const [view, setView] = useState<TableViewType>("list");

  const ViewSwitchComponent = (
    <ViewSwitch views={VIEWS} onChange={setView} selectedView={view} />
  );

  return (
    <Box>
      <>
        <RoundedBox>
          <LiveOnlineCatalogFilter view={view} onChange={setFilter} />
        </RoundedBox>
        <RoundedBox>
          {view === "list" && (
            <ListView filter={filter} viewSwitch={ViewSwitchComponent} />
          )}
          {view === "calendar" && <CalendarView filter={filter} viewSwitch={ViewSwitchComponent}  />}
        </RoundedBox>
      </>
    </Box>
  );
}
